import {useCallback, useRef} from 'react';

// Wraps a react-query `mutate` so a second call is ignored while the first is
// still running. `isPending` reaches the button a tick late, so a fast double
// click could otherwise send the request twice (e.g. adjust a balance twice).
export const useGuardedMutate = <TVariables>(
  mutate: (variables: TVariables, options?: {onSettled?: () => void}) => void,
) => {
  const busy = useRef(false);
  return useCallback(
    (variables: TVariables) => {
      if (busy.current) return;
      busy.current = true;
      mutate(variables, {
        onSettled: () => {
          busy.current = false;
        },
      });
    },
    [mutate],
  );
};
